import { yup } from '@framework/validation/initYup.ts';
import { unionSchema } from '@framework/validation/union/unionSchema.ts';
import { LazyWidgetSchema } from '../../../LazyWidgetSchema.ts';
import { widgetCodeSchema } from '../../../validation/widgetCodeSchema.tsx';
import { type Widget } from '../../../Widget.ts';

export enum TableCellType {
  Widget = 'widget',
  Empty = 'empty',
}

export interface ITableWidgetCell {
  type: TableCellType.Widget;
  columnId?: string | null;
  widget: Widget;
}

/**
 * @deprecated Deprecato in quanto al momento non supportato. Andrebbe
 * implementato.
 */
export interface ITableEmptyCell {
  type: TableCellType.Empty;
  columnCode?: string;
}

export type ITableCell = ITableWidgetCell | ITableEmptyCell;

export const TableWidgetCellSchema: yup.ObjectSchema<ITableWidgetCell> = yup
  .object({
    type: yup.string().exact(TableCellType.Widget).required(),
    columnId: yup.string().uuid().notRequired().label('Colonna'),
    widget: LazyWidgetSchema,
  })
  .noUnknown();

export const TableEmptyCellSchema: yup.ObjectSchema<ITableEmptyCell> = yup
  .object({
    type: yup.string().exact(TableCellType.Empty).required(),
    columnCode: widgetCodeSchema.label('Colonna'),
  })
  .noUnknown();

export const TableCellSchema = unionSchema<ITableWidgetCell | ITableEmptyCell>([
  TableWidgetCellSchema,
  TableEmptyCellSchema,
]);
